
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonList,
  IonListHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonTitle,
  IonSearchbar,
  IonToolbar,
  modalController
} from "@ionic/vue";
import { defineComponent, ref} from "vue";
import { County } from "@/models/county";
import { closeOutline } from "ionicons/icons";

export default defineComponent({
  name: "Modal",
  setup() {
    const search = ref('')
    return { closeOutline, search };
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonList,
    IonListHeader,
    IonItem,
    IonLabel,
    IonSearchbar,
    IonTitle,
    IonToolbar
  },
  computed: {
    counties(): any {
      return this.$store.state.counties;
    },
  },
  mounted() {
    if (!this.counties || !this.counties.length) {
      this.searchCounties()
    } 
  },
  methods: {
    closeMe(c: County) {
      modalController.dismiss(c)
    },
    searchCounties() {
      this.$store.dispatch("getCounties", this.search ? this.search.trim() : '')
    }
  }
});
